module.exports = "../content/d8de52e6c5df1a987ef6b9126a70cfcc.ttf";